import React from 'react';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

type PunchProgressProps = {
  used: number;
  total: number | null;
  large?: boolean;
};

export const PunchProgress = ({ used, total, large = false }: PunchProgressProps) => {
  const { t } = useTranslation();

  if (total === null) {
    return (
      <Grid container alignItems="center" gap={1}>
        <Typography variant={large ? 'h6' : 'subtitle1'} fontWeight={600}>
          {t('manage_passes.pass.punchesUsedCount', { count: used })}
        </Typography>
        <Chip label={`∞ ${t('manage_passes.pass.status.unlimited')}`} color="primary" variant="outlined" size="small" />
      </Grid>
    );
  }

  const percentage = total > 0 ? (used / total) * 100 : 0;
  const remaining = total - used;

  return (
    <Grid container flexDirection="column" gap={0.5}>
      <LinearProgress
        variant="determinate"
        value={percentage}
        sx={{
          height: large ? 14 : 10,
          borderRadius: 8,
          backgroundColor: 'rgba(0,0,0,0.06)',
          '& .MuiLinearProgress-bar': {
            borderRadius: 8,
          },
        }}
      />
      <Grid container justifyContent="space-between">
        <Typography variant="body2">{t('manage_passes.pass.punchesUsed', { used, total })}</Typography>
        <Typography variant="body2" color="text.secondary">
          {t('manage_passes.pass.remaining', { count: remaining })}
        </Typography>
      </Grid>
    </Grid>
  );
};
